"use client";

import React, { useState, useEffect } from 'react';
import MainLayout from '@/layouts/MainLayout';
import Hero from '@/components/Hero';
import Features from '@/components/Features';
import TestimonialWall from '@/components/TestimonialWall';
import useBrowserDetection from '@/hooks/useBrowserDetection';
import CallToAction from '@/components/CallToAction';
import HowItWorks from '@/components/HowItWorks';
import SocialProof from '@/components/SocialProof';
import { useToast } from '@/hooks/use-toast';
import { ToastAction } from '@/components/ui/toast';

const Home = () => {
  const { isChrome, isBrowserDetected, hasWarningBeenDismissed } = useBrowserDetection();
  const { toast } = useToast();
  
  // Show browser warning if not using Chrome and warning hasn't been dismissed
  useEffect(() => {
    if (isBrowserDetected && !isChrome && !hasWarningBeenDismissed) {
      // Reduced delay to improve LCP
      const timer = setTimeout(() => {
        toast({
          title: "Browser Warning",
          description: "Please use Chrome for the best experience.",
          variant: "destructive",
          action: (
            <ToastAction
              altText="Get Chrome"
              onClick={() => {
                window.open("https://www.google.com/chrome/", "_blank");

                localStorage.setItem('browser-warning-dismissed', 'true');
              }}
            >
              Get Chrome
            </ToastAction>
          ),
        });
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [isBrowserDetected, isChrome, hasWarningBeenDismissed, toast]);

  return (
    <MainLayout fullWidthHero={true}>
      {/* Hero section without container constraints */}
      <div className="mt-4">
        <Hero />
      </div>

      {/* Social Proof section outside the container */}
      <div id="social-proof">
        <SocialProof />
      </div>
      
      {/* Rest of content with container */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <main className="flex flex-col justify-between items-stretch">
          <div id="how-it-works" className="">
            <HowItWorks />
          </div>
          <div className="border-b border-dashed border-white/10 mt-14"></div>
          <div id="features" className="">
            <Features />
          </div>
          <div id="testimonials">
            <TestimonialWall />
          </div>
          <div className="py-0">
            <CallToAction />
          </div>
        </main>
      </div>
    </MainLayout>
  );
};

export default Home;